<template>
  <div class="rp_content">
    <div class="rp_head">
      <div class="rp_back" @click="getBack('ruleForm')">返回</div>
      <div class="rp_title">招聘要求</div>
      <div class="rp_back" @click="getModel()">范例</div>
    </div>

    <div class="rp_form" v-show="ruleFormVisible">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="auto"
        class="demo-ruleForm"
      >
        <el-form-item
          label="公司名称（Company Name）"
          prop="Company"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-input
            v-model="ruleForm.Company"
            placeholder="请填写公司名称"
            :disabled="editDisabled"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="公司介绍（Company Introduction）"
          prop="Introduction"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.Introduction"
            placeholder="请填写本公司介绍"
            maxlength="1000"
            show-word-limit
            :autosize="{ minRows: 12 }"
            :disabled="editDisabled"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="公司联系方式（Company Contact information）"
          prop="ContactInfo"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.ContactInfo"
            placeholder="请填写公司联系方式"
            maxlength="200"
            show-word-limit
            :autosize="{ minRows: 6 }"
            :disabled="editDisabled"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="职位分类（Job Classification）"
          prop="Type"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-radio-group v-model="ruleForm.Type" :disabled="editDisabled">
            <el-radio :label="1">开发类</el-radio>
            <el-radio :label="2">运营类</el-radio>
            <el-radio :label="3">设计类</el-radio>
            <el-radio :label="4">销售类</el-radio>
            <el-radio :label="5">产品类</el-radio>
            <el-radio :label="0">其它</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="职位（Job）"
          prop="Title"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-input
            v-model="ruleForm.Title"
            placeholder="请填写需要招聘的职位"
            :disabled="editDisabled"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="办公方式（Office Mode）"
          prop="OfficeModeName"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-radio-group
            v-model="ruleForm.OfficeModeName"
            :disabled="editDisabled"
          >
            <el-radio :label="0">远程</el-radio>
            <!-- <el-radio :label="1">在职</el-radio> -->
            <el-radio :label="2">现场</el-radio>
            <el-radio :label="3">无要求</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="工作地点（Work Location）"
          prop="WorkLocation"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-input
            v-model="ruleForm.WorkLocation"
            placeholder="请填写工作地点"
            maxlength="32"
            show-word-limit
            :autosize="{ minRows: 1 }"
            :disabled="editDisabled"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="工作类型（Work Type）"
          prop="WorkTypeName"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-radio-group
            v-model="ruleForm.WorkTypeName"
            :disabled="editDisabled"
          >
            <el-radio :label="0">全职</el-radio>
            <el-radio :label="1">兼职</el-radio>
            <el-radio :label="2">全职/兼职</el-radio>
            <el-radio :label="3">无要求</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="薪资范围（Salary）"
          prop="Salary"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-input
            v-model="ruleForm.Salary"
            placeholder="薪资范围"
            :disabled="editDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="福利待遇（Welfare Treatment）"
          prop="WelfareTreatment"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.WelfareTreatment"
            placeholder="请描述本公司能为求职者提供的福利待遇"
            maxlength="1000"
            show-word-limit
            :autosize="{ minRows: 12 }"
            :disabled="editDisabled"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="职位描述（Job Description）"
          prop="TitleDescription"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.TitleDescription"
            placeholder="请详细描述该职位职责"
            maxlength="1000"
            show-word-limit
            :autosize="{ minRows: 12 }"
            :disabled="editDisabled"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="职位要求（Job Requirements）"
          prop="TitleRequirements"
          label-position="top"
          label-width="auto"
          inline="false"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.TitleRequirements"
            placeholder="请详细描述应聘者需要达到的应聘要求"
            maxlength="1000"
            show-word-limit
            :autosize="{ minRows: 12 }"
            :disabled="editDisabled"
          >
          </el-input>
        </el-form-item>

        <el-form-item class="re_form_bottom" v-if="recruitStatus == 1">
          <el-button type="danger" @click="requestDeleteRecruit()"
            >删除</el-button
          >
          <el-button type="info" @click="requestGetJobUpdate(5)"
            >下架</el-button
          >
        </el-form-item>

        <el-form-item
          class="re_form_bottom"
          v-else-if="
            recruitStatus == 2 || recruitStatus == 4 || recruitStatus == 5
          "
        >
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交审核</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置信息</el-button>
        </el-form-item>

        <el-form-item
          class="re_form_bottom"
          v-else-if="recruitStatus == 3 && Status == 0"
        >
          <el-button type="danger" @click="requestDeleteRecruit()"
            >删除</el-button
          >
          <el-button type="info" @click="requestGetJobUpdate(2)"
            >撤回</el-button
          >
        </el-form-item>

        <el-form-item
          class="re_form_bottom"
          v-else-if="recruitStatus == 3 && Status == 1"
        >
          <el-button type="success" @click="requestGetJobUpdate(1)"
            >通过</el-button
          >
          <el-button @click="requestGetJobUpdate(4)">不通过</el-button>
        </el-form-item>

        <el-form-item class="re_form_bottom" v-else>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交审核</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置信息</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  getJobAdd,
  getJobDetail,
  getJobUpdate,
  getJobDelete,
} from "@/config/api.js";
import {
  Form,
  FormItem,
  Input,
  Button,
  Message,
  RadioGroup,
  Radio,
} from "element-ui";
Vue.use(Form).use(FormItem).use(Input).use(Button).use(RadioGroup).use(Radio);
Vue.prototype.$message = Message;
export default {
  data() {
    return {
      ruleFormVisible: true,
      ruleForm: {
        Company: "", // 公司名称
        Introduction: "", // 公司介绍
        ContactInfo: "", // 公司联系方式
        Title: "", // 职位
        OfficeModeName: 3, // 办公方式
        WorkLocation: "", // 工作地点
        WorkTypeName: 3, // 工作类型
        Salary: "", // 薪资范围
        WelfareTreatment: "", // 福利待遇
        TitleDescription: "", // 职位描述
        TitleRequirements: "", // 职位要求
        Type: 0, // 职位分类
      },
      rules: {
        Company: [
          { required: true, message: "请填写本公司名称", trigger: "blur" },
        ],
        Introduction: [
          { required: false, message: "请填写本公司介绍", trigger: "blur" },
        ],
        ContactInfo: [
          { required: true, message: "请填写公司联系方式", trigger: "blur" },
        ],
        Title: [
          { required: true, message: "请填写需要招聘的职位", trigger: "blur" },
        ],
        OfficeModeName: [
          {
            required: true,
            message: "请描述公司的办公方式",
            trigger: "change",
          },
        ],
        WorkLocation: [
          { required: false, message: "请填写公司的工作地点", trigger: "blur" },
        ],
        WorkTypeName: [
          {
            required: true,
            message: "请描述公司的工作类型",
            trigger: "change",
          },
        ],
        Salary: [
          { required: true, message: "请填写薪资范围", trigger: "blur" },
        ],
        WelfareTreatment: [
          {
            required: false,
            message: "请描述本公司能为求职者提供的福利待遇",
            trigger: "blur",
          },
        ],
        TitleDescription: [
          { required: true, message: "请详细描述该岗位职责", trigger: "blur" },
        ],
        TitleRequirements: [
          {
            required: true,
            message: "请详细描述应聘者需要达到的应聘要求",
            trigger: "blur",
          },
        ],
        Type: [
          { required: true, message: "请选择职位分类", trigger: "change" },
        ],
      },
      editDisabled: false, // 是否可编辑
      recruitStatus: -1, // 信息状态

      Uid: "", // uid
      Status: 0, // 角色
    };
  },
  beforeMount() {
    // 0 删除 1 审核通过 2 取消审核 3 提交审核 4 审核未通过 5 下架
    var that = this;

    var queryData = this.$route.query;
    if (queryData.hasOwnProperty("article")) {
      that.ruleFormVisible = false;
      that.requestGetJobDetail(queryData.article);
    }
    if (queryData.hasOwnProperty("editDisabled")) {
      if (queryData.editDisabled == 1) {
        that.editDisabled = true;
        that.recruitStatus = 1;
      } else if (queryData.editDisabled == 4) {
        that.editDisabled = false;
        that.recruitStatus = 4;
      } else if (queryData.editDisabled == 3) {
        that.editDisabled = true;
        that.recruitStatus = 3;
      } else if (queryData.editDisabled == 2) {
        that.editDisabled = false;
        that.recruitStatus = 2;
      } else if (queryData.editDisabled == 5) {
        that.editDisabled = false;
        that.recruitStatus = 5;
      }
    }

    if (that.$route.path == "/post") {
      // 读取github信息
      const savedString = localStorage.getItem("github");
      if (savedString != "" && savedString != null) {
        that.githubInfo = JSON.parse(savedString);
        that.Uid = that.githubInfo.uid;
        that.Status = that.githubInfo.status;
      } else if (savedString == "" || savedString == null) {
        that.$message({
          message: "请先登录Github",
          type: "warning",
          duration: 3000,
        });

        that.$router.push({
          path: "/",
        });
      }
    }
  },
  methods: {
    // 提交
    submitForm(formName) {
      var that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.ruleForm.hasOwnProperty("ID")) {
            that.requestGetJobUpdate(3);
          } else {
            that.requestGetJobAdd();
          }
        } else {
          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 返回上一页
    getBack(formName) {
      var that = this;
      that.$refs[formName].resetFields();
      that.$router.go(-1);
    },
    // 新建招聘信息
    requestGetJobAdd() {
      var that = this;
      var params = {
        Company: that.ruleForm.Company, // 公司名称
        Introduction: that.ruleForm.Introduction, // 公司介绍
        ContactInfo: that.ruleForm.ContactInfo, // 公司联系方式
        Title: that.ruleForm.Title, // 职位
        OfficeModeName: that.ruleForm.OfficeModeName.toString(), // 办公方式
        WorkLocation: that.ruleForm.WorkLocation, // 工作地点
        WorkTypeName: that.ruleForm.WorkTypeName.toString(), // 工作类型
        Salary: that.ruleForm.Salary, // 薪资范围
        WelfareTreatment: that.ruleForm.WelfareTreatment, // 福利待遇
        TitleDescription: that.ruleForm.TitleDescription, // 职位描述
        TitleRequirements: that.ruleForm.TitleRequirements, // 职位要求
        Type: that.ruleForm.Type, // 分类

        Uid: that.Uid,
      };
      getJobAdd(JSON.stringify(params)).then((res) => {
        if (res.data == 200200) {
          that.$message({
            message: "提交审核成功！",
            type: "success",
          });

          that.$router.push({
            path: "/apply",
            query: { refresh: "1" },
          });
        } else {
          alert(res.message);
        }
      });
    },
    // 查询jobDetail
    requestGetJobDetail(article) {
      var that = this;
      var params = {
        article: article,
      };
      getJobDetail(params).then((res) => {
        if (res.data) {
          that.ruleForm = res.data;

          if (that.ruleForm.OfficeModeName == "远程") {
            that.ruleForm.OfficeModeName = 0;
          } else if (that.ruleForm.OfficeModeName == "在职") {
            that.ruleForm.OfficeModeName = 1;
          } else if (that.ruleForm.OfficeModeName == "现场") {
            that.ruleForm.OfficeModeName = 2;
          } else if (that.ruleForm.OfficeModeName == "无要求") {
            that.ruleForm.OfficeModeName = 3;
          }

          if (that.ruleForm.WorkTypeName == "全职") {
            that.ruleForm.WorkTypeName = 0;
          } else if (that.ruleForm.WorkTypeName == "兼职") {
            that.ruleForm.WorkTypeName = 1;
          } else if (that.ruleForm.WorkTypeName == "全职/兼职") {
            that.ruleForm.WorkTypeName = 2;
          } else if (that.ruleForm.WorkTypeName == "无要求") {
            that.ruleForm.WorkTypeName = 3;
          }

          that.ruleFormVisible = true;
        }
      });
    },
    // 更新招聘信息
    requestGetJobUpdate(status) {
      var that = this;
      var params = {
        Company: that.ruleForm.Company, // 公司名称
        Introduction: that.ruleForm.Introduction, // 公司介绍
        ContactInfo: that.ruleForm.ContactInfo, // 公司联系方式
        Title: that.ruleForm.Title, // 职位
        OfficeModeName: that.ruleForm.OfficeModeName.toString(), // 办公方式
        WorkLocation: that.ruleForm.WorkLocation, // 工作地点
        WorkTypeName: that.ruleForm.WorkTypeName.toString(), // 工作类型
        Salary: that.ruleForm.Salary, // 薪资范围
        WelfareTreatment: that.ruleForm.WelfareTreatment, // 福利待遇
        TitleDescription: that.ruleForm.TitleDescription, // 职位描述
        TitleRequirements: that.ruleForm.TitleRequirements, // 职位要求
        Type: that.ruleForm.Type, // 分类

        ID: that.ruleForm.ID,
        Uid: that.Uid,
        Status: status,
      };
      getJobUpdate(JSON.stringify(params)).then((res) => {
        if (res.data == 200200) {
          that.$message({
            message: res.message,
            type: "success",
          });

          that.$router.push({
            path: "/apply",
            query: { refresh: "1" },
          });
        }
      });
    },
    // 删除招聘信息
    requestDeleteRecruit() {
      var that = this;
      var params = {
        ID: that.ruleForm.ID,
        Uid: that.Uid,
      };
      getJobDelete(JSON.stringify(params)).then((res) => {
        if (res.data) {
          that.$message({
            message: res.message,
            type: "success",
          });

          that.$router.push({
            path: "/apply",
            query: { refresh: "1" },
          });
        }
      });
    },
    // 获取范例
    getModel() {
      window.open("http://job.hitadao.com/jobs/job-1972.html", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.rp_content {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: #f2f4f6;

  padding: 60px 18.75% 0 18.75%;

  .rp_head {
    margin: 88px 0 0 0;
    width: calc(100%);
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .rp_title {
      width: calc(100% - 164px);
      height: 40px;
      font-weight: bold;
      font-size: 26px;
      color: #000000;
      line-height: 40px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .rp_back {
      width: 80px;
      height: 40px;
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #000000;

      font-weight: normal;
      font-size: 16px;
      color: #000000;
      line-height: 38px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      cursor: pointer;
    }
  }

  .rp_form {
    margin: 78px 0 0 0;
    padding: 0 0 148px 0;

    .re_form_bottom {
      margin: 94px 0 0 0;
      text-align: center;
    }
  }
}

@media screen and (max-width: 958px) {
  .rp_content {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background: #f2f4f6;

    padding: 60px 4.6875% 0 4.6875%;

    .rp_head {
      margin: 44px 0 0 0;
      width: calc(100%);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .rp_title {
        width: calc(100% - 164px);
        height: 40px;

        font-weight: bold;
        font-size: 26px;
        color: #000000;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .rp_back {
        width: 80px;
        height: 40px;
        border-radius: 20px 20px 20px 20px;
        border: 1px solid #000000;

        font-weight: normal;
        font-size: 16px;
        color: #000000;
        line-height: 38px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        cursor: pointer;
      }
    }

    .rp_form {
      margin: 39px 0 0 0;
      padding: 0 0 74px 0;

      .re_form_bottom {
        margin: 47px 0 0 0;
        text-align: center;
      }
    }
  }
}

/deep/.el-form-item__content {
  margin: 0 0 0 0 !important;
}
/deep/.el-form-item__label-wrap {
  margin: 0 0 0 0 !important;
}
</style>